import { InstoreCategory } from '../containers/instore';

export const getInstoreCategoryData = (category: InstoreCategory, storeLink: string | null) => {
	const { categoryUrl } = category;
	const link = categoryUrl.includes(storeLink) ? categoryUrl : `${categoryUrl}/${storeLink}/`;

	return {
		...category,
		categoryUrl: storeLink ? link : `${categoryUrl}/`,
	};
};
